import Transformer from './../transformer'
import { fullName } from '@/transformers/jbUser'

export default class HighwaySectionTransformer extends Transformer {
  static fetch(hsection) {
    const attendant = hsection.attendant || {}
    const administrative = hsection.administrative || {}
    const highwaySectionAttendantName = fullName(hsection.attendant)

    return {
      id: hsection.id,
      start: hsection.initial_kilometer,
      end: hsection.final_kilometer,
      highway: hsection.highway.highway_id,
      highwayName: hsection.highway.highway_name,
      name: hsection.name,
      highwaySectionNumber: hsection.highway_section_number,
      highwaySectionAttendant: attendant.id,
      highwaySectionAttendantName,
      state: hsection.state.id,
      administrativeId: (administrative.id) ? administrative.id : null,
      administrativeChieff: (administrative.administrative) ? administrative.administrative.administrative_id : null,
      administrativeChieffName: (administrative.administrative) ? administrative.administrative.administrative_name : null,
      camp: hsection.camp,
      receive: administrative.receive,
      resident: hsection.resident,
    }
  }

  static send(hsection) {
    return {
      id: hsection.id,
      highway_section_data: {
        id: hsection.id,
        attendant: hsection.highwaySectionAttendant,
        highway: hsection.highway,
        state: hsection.state,
        highway_section_number: hsection.highwaySectionNumber,
        name: hsection.name,
        initial_kilometer: hsection.start,
        final_kilometer: hsection.end,
        camp: hsection.camp,
      },
      administrative_data: {
        administrative: hsection.administrativeChieff,
        receive: hsection.receive,
      },
    }
  }
}



// WEBPACK FOOTER //
// ./src/transformers/catalog/highwaySection.js